<style lang="less" scoped>
	.separator{
		display: inline-flex;
		margin-left: 6px;
		padding-left: 8px;
		border-left: 1px solid #dfdddd;
	}
	.editorToolbar{
		display: inline-table;
		min-width: 100%;
		z-index: 1000;
		position: absolute;
		bottom: -45px;
		padding: 2px 5px;
		.v-toolbar__content{
			display: contents;
		}
	}

	input.x-small{
		font-size: 12px;
		padding: 2px 3px;
		width: 45px;
		border: 1px solid grey;
	}
	input.small{
		font-size: 12px;
		padding: 2px 3px;
		border: 1px solid grey;
	}
</style>
<template>
		<v-app-bar dense class="editorToolbar" color="#efefef">
				<v-btn x-small text color="red" class="mr-2" @click="$emit('delete', element )">Delete</v-btn>
				<span class="separator" v-if="elementSupports('flat') || elementSupports('width')" >
					<v-btn v-if="elementSupports('flat')" class="mr-2" x-small text @click="element.attrs.flat = !element.attrs.flat" style="min-width: 62px">{{element.attrs.flat ? 'flat' : 'border'}}</v-btn>
					<input type="text" v-if="elementSupports('width')" class="mr-2 x-small" v-model="element.attrs.width" />
				</span>
				<input v-if="elementSupports('imgUrl')" type="text" class="mr-2 small" v-model="element.attrs.imgUrl" placeholder="Img Url" />
				<input v-if="elementSupports('height')" type="text" class="mr-2 small" v-model="element.attrs.height" placeholder="Height" />
				<span class="separator" v-if="element.key == 'button'" >
					<input type="text" class="mr-2 small" v-model="element.link" placeholder="Link" />
					<input type="text" class="mr-2 small" v-model="element.text" placeholder="Text" />
					<input type="text" class="mr-2 small" v-model="element.buttonIcon" placeholder="Icon" />
				</span>
				<v-chip v-if="elementSupports('size')" color="white" @click="toggleSize" class="mr-2"><span class="overline">{{element.attrs.size}}</span></v-chip>

				<v-btn v-if="elementSupports('dark')" class="ml-0" x-small color="grey" :dark="element.attrs.dark" @click="element.attrs.dark = !element.attrs.dark" style="min-width: 52px">{{element.attrs.dark ? 'dark' : 'light'}}</v-btn>
				<v-btn v-if="elementSupports('text')" class="ml-2" x-small color="grey" :text="element.attrs.text" @click="element.attrs.text = !element.attrs.text" style="min-width: 52px">{{element.attrs.text ? 'text' : 'tile'}}</v-btn>

				<v-chip color="white" class="ml-2" v-if="elementSupports('padding')"><EditorPaddingAndMargin :current="element.attrs.padding" type="padding" v-on:change="(a) => { element.attrs.padding = a }"></EditorPaddingAndMargin></v-chip>
				<v-chip color="white" class="ml-2" v-if="elementSupports('margin')"><EditorPaddingAndMargin :current="element.attrs.margin" type="margin" v-on:change="(a) => { element.attrs.margin = a }"></EditorPaddingAndMargin></v-chip>
				
				<EditorColors v-if="elementSupports('colors')"  class="separator" :values="element.attrs.colors"  v-on:change="(type, value) => { element.attrs.colors[type] = value }"></EditorColors>
				
				<EditorAlignment v-if="elementSupports('alignment')"  class="separator" :values="element.attrs.alignment" type="alignment" v-on:change="(value, focus ) => {  element.attrs.alignment[focus] = value }"></EditorAlignment>
				
				<EditorTypography v-if="elementSupports('typography')"  class="separator" :values="element.attrs.typography" type="typography" v-on:change="(value, focus ) => { element.attrs.typography[focus] = value }"></EditorTypography>
				
				
				<div class="separator" v-if="elementSupports('cols')">
					<EditorColumnWidths :element="element" v-on:increase="(size) => { element.attrs[size]++ }"  v-on:decrease="(size) => { element.attrs[size]-- }"></EditorColumnWidths>
				</div>
		</v-app-bar>	
</template>


<script>
	
	export default{
		name: "EditorToolbar", 
		props: {
			element: {type: Object} 
		}, 
		components: {
			EditorColumnWidths:  () => import("../TextEditor/EditorColumnWidths"),
			EditorPaddingAndMargin: () => import("../TextEditor/EditorPaddingAndMargin.vue"),
			EditorColors: () => import("../TextEditor/EditorColors.vue"),
			EditorTypography: () => import("../TextEditor/EditorTypography.vue"),
			EditorAlignment: () => import("../TextEditor/EditorAlignment.vue"),
		},
		methods: {
			elementSupports(key){
				if( typeof this.element.attrs[key] == 'undefined' ){
					return false;
				}
				return true;
			},
			toggleSize(){
				var sizes = ['default', 'x-small', 'small', 'large', 'x-large', 'block' ];
				var currentIndex = sizes.indexOf( this.element.attrs.size );
				currentIndex ++;
				if( currentIndex == sizes.length ){
					currentIndex = 0;
				}
				this.element.attrs.size = sizes[currentIndex]

			}

		}
	}
</script>